import { PlaceholderCard } from '@components/admin/PlaceholderCard';
import * as Icons from '@components/Icons';
import { GoogleCalendarCard } from './GoogleCalendarCard';

export function NotificacionesSection() {
  const toggles: [string, string, boolean][] = [
    ['Confirmación de reserva', 'Email + SMS cuando se confirma una reserva.', true],
    ['Recordatorio 24h antes', 'SMS al cliente 24 horas antes de la cita.', true],
    ['Aviso de cancelación', 'Email cuando se cancela una reserva por cualquier parte.', true],
    ['Marketing y promociones', 'Newsletter mensual con bonos y novedades.', false],
    ['Resumen semanal interno', 'Email los lunes con KPIs de la semana al equipo admin.', true],
  ];
  return (
    <PlaceholderCard
      title="Notificaciones a clientes"
      description="Activa los avisos automáticos por email y SMS."
      preview={
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {toggles.map(([title, desc, on], i) => (
            <div
              key={title}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 12,
                padding: '12px 0',
                borderTop: i === 0 ? 'none' : '1px solid var(--border)',
              }}
            >
              <div>
                <div style={{ fontSize: 13.5, fontWeight: 500 }}>{title}</div>
                <div style={{ fontSize: 12, color: 'var(--fg-muted)' }}>{desc}</div>
              </div>
              <div className="switch" data-on={on} aria-disabled="true" />
            </div>
          ))}
        </div>
      }
    />
  );
}

export function PagosSection() {
  return (
    <PlaceholderCard
      title="Pagos"
      description="Cobro online en la reserva o en el centro."
      preview={
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0' }}>
            <div>
              <div style={{ fontSize: 13.5, fontWeight: 500 }}>Stripe</div>
              <div className="mono" style={{ fontSize: 11.5, color: 'var(--fg-muted)' }}>Sin conectar</div>
            </div>
            <button className="btn" disabled>Conectar Stripe</button>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, padding: '12px 0', borderTop: '1px solid var(--border)' }}>
            <div>
              <div style={{ fontSize: 13.5, fontWeight: 500 }}>Cobro online obligatorio</div>
              <div style={{ fontSize: 12, color: 'var(--fg-muted)' }}>El cliente paga al reservar. Si está apagado, se paga en el centro.</div>
            </div>
            <div className="switch" data-on={false} aria-disabled="true" />
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, padding: '12px 0', borderTop: '1px solid var(--border)' }}>
            <div>
              <div style={{ fontSize: 13.5, fontWeight: 500 }}>Depósito reembolsable</div>
              <div style={{ fontSize: 12, color: 'var(--fg-muted)' }}>Cobrar 10€ al reservar, descontables en la sesión.</div>
            </div>
            <div className="switch" data-on={false} aria-disabled="true" />
          </div>
        </div>
      }
    />
  );
}

/** Solo placeholders. La sección real con Google Calendar vive en
 *  `IntegracionesSection` (este mismo archivo) — cableado abajo. */
function placeholderItems(): [string, string][] {
  return [
    ['Mailchimp', 'Lista de clientes para envíos de marketing.'],
    ['Zapier', 'Webhooks para automatizar acciones tras una reserva.'],
    ['HubSpot CRM', 'Sincroniza clientes y contactos.'],
  ];
}

export function IntegracionesSection() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <GoogleCalendarCard />
      <PlaceholderCard
        title="Otras integraciones"
        description="Conecta más servicios externos (pendiente)."
        preview={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {placeholderItems().map(([name, desc], i) => (
              <div
                key={name}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 12,
                  padding: '12px 0',
                  borderTop: i === 0 ? 'none' : '1px solid var(--border)',
                }}
              >
                <div>
                  <div style={{ fontSize: 13.5, fontWeight: 500 }}>{name}</div>
                  <div style={{ fontSize: 12, color: 'var(--fg-muted)' }}>{desc}</div>
                </div>
                <button className="btn" disabled>Conectar</button>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
}

/** Plataforma: Marca global del producto (BrandConfig). Solo superadmin. */
export function MarcaPlataformaSection() {
  return (
    <PlaceholderCard
      title="Marca (plataforma)"
      description="Identidad del producto SaaS — visible en emails, .ics y panel de marketing. No depende de ningún centro."
      preview={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="field-row">
            <div className="field">
              <label className="field-label">Nombre del producto</label>
              <input className="input" disabled placeholder="EquipoMag" />
            </div>
            <div className="field">
              <label className="field-label">Color principal</label>
              <input className="input mono" disabled placeholder="#2F7A4F" />
            </div>
          </div>
          <div className="field">
            <label className="field-label">Logo</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 6, background: 'var(--bg-2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--fg-muted)' }}>
                <Icons.Tag size={14} />
              </div>
              <button className="btn" disabled>Subir logo</button>
            </div>
          </div>
          <div className="field">
            <label className="field-label">Dominio de email</label>
            <input className="input mono" disabled placeholder="equipomag.com" />
          </div>
        </div>
      }
    />
  );
}
